import type { Faq } from './services/faqService'

export const SAMPLE_FAQS: Faq[] = [
  {
    id: '00000000-0000-0000-0000-000000000001',
    title: 'O que é o Cripto Alert?',
    content: 'É um radar de oportunidades com governança por fechamento, focado em clareza e disciplina operacional.',
    position: 1,
  },
  {
    id: '00000000-0000-0000-0000-000000000002',
    title: 'Preciso manter o navegador aberto para receber alertas?',
    content: 'Não. Os alertas via web push funcionam mesmo com o app fechado, desde que tenha opt-in e permissão ativa.',
    position: 2,
  },
  {
    id: '00000000-0000-0000-0000-000000000003',
    title: 'Quais timeframes são monitorados?',
    content: 'Os principais TFs de 1m a 1D, com regras de histerese e mandante. Detalhes na documentação oficial.',
    position: 3,
  },
]

